import { createSlice } from '@reduxjs/toolkit';
import {
  addOverlayReducer,
  deleteOverlayReducer,
  getAllPublicOverlaysByProjectIdReducer,
  getAllProjectOverlaysReducer,
  getAllUserOverlaysByCreatorReducer,
  getOverlayReducer,
  removeOverlayReducer,
  updateOverlaysReducer,
  updateSingleOverlayReducer,
  fetchOverlayTypesReducer,
} from './overlays.reducers';
import { OverlaysState } from './overlays.types';

const initialState: OverlaysState = {
  data: [],
  loading: 'idle',
  error: { name: '', message: '' },
  addOverlay: {
    loading: 'idle',
    error: { name: '', message: '' },
  },
  userOverlays: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
  projectOverlays: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
  updateOverlays: {
    loading: 'idle',
    error: { name: '', message: '' },
  },
  removeOverlay: {
    loading: 'idle',
    error: { name: '', message: '' },
  },
  updateSingleOverlay: {
    loading: 'idle',
    error: { name: '', message: '' },
  },
  overlayTypes: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
};

const overlaysState = createSlice({
  name: 'overlays',
  initialState,
  reducers: {
    deleteOverlay: deleteOverlayReducer,
  },
  extraReducers: builder => {
    getAllPublicOverlaysByProjectIdReducer(builder);
    getAllProjectOverlaysReducer(builder);
    addOverlayReducer(builder);
    getAllUserOverlaysByCreatorReducer(builder);
    getOverlayReducer(builder);
    updateOverlaysReducer(builder);
    removeOverlayReducer(builder);
    updateSingleOverlayReducer(builder);
    fetchOverlayTypesReducer(builder);
  },
});

export const { deleteOverlay } = overlaysState.actions;

export default overlaysState.reducer;
